export default __webpack_public_path__ + "static/media/so.0f00cd2e.svg";